import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Add smooth scrolling behavior
    });
  };


  const currentYear = new Date().getFullYear();


  return (
    <div>
    <footer className="thm-bg-color-two section-padding section footer">
        <div className="container">
            <div className="row">
                <div className="col-lg-5">
                    <div className="ft_widgets">
                        <div className="ft_about">
                            <img src="/tm/react/roboto/assets/images/logo.png" alt="logo" className="image-fit-contain"/>
                            <p className="text-white mb-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco</p>
                            <ul className="ft_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6">
                    <div className="ft_widgets">
                        <h6 className="ft_title">Menu</h6>
                        <ul className="ft_menu">
                            <li>
                                <Link to="/index">Home</Link>
                            </li>
                            <li>
                                <Link to="/about">About</Link>
                            </li>
                            <li>
                                <Link to="/team">Team</Link>
                            </li>
                            <li>
                                <Link to="/blog-grid">Blog</Link>
                            </li>
                            <li>
                                <Link to="/contact">Contact</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6">
                    <div className="ft_widgets">
                        <h6 className="ft_title">Services</h6>
                        <ul className="ft_menu">
                            <li>
                                <Link to="/service-details">Machine Learning</Link>
                            </li>
                            <li>
                                <Link to="/service-details">Manage Analytics</Link>
                            </li>
                            <li>
                                <Link to="/service-details">Industrial Robot</Link>
                            </li>
                            <li>
                                <Link to="/service-details">Data Analsis</Link>
                            </li>
                            <li>
                                <Link to="/service-details">Robot Learning</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4">
                    <div className="ft_widgets">
                        <h6 className="ft_title">Support</h6>
                        <p className="text-white mb-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
                        <ul className="ft_contact ft_menu">
                            <li>
                                <Link to="#">
                                    <i className="fas fa-phone-volume"></i>
                                    (+347) 123 456 7890
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fas fa-envelope"></i>
                                    example@example.com
                                </Link>
                            </li><li>
                                <Link to="#">
                                    <i className="fas fa-map-marker-alt"></i>
                                    Street, 3821 Ben Street. NY 14424
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    {/* <!-- Footer End -->
    <!-- Copyright Start --> */}
    <div className="thm-bg-color-one copyright">
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <p className="mb-0">Copyright © <Link to="#">Website</Link><span id="year"> {currentYear}</span>.</p>
                </div>
            </div>
        </div>
    </div>
    {isSticky && (
    <Link to="#" data-target="html" className="back-to-top ft-sticky" onClick={scrollToTop}>
        <i className="fal fa-long-arrow-up"></i>
    </Link>
    )}
    </div>
  )
}

export default Footer